
import "../Services/ServiceHomePage.css";

const ServiceHomePage = () => {
    return (
        <div id="service" className="main-container">
            <div className="main-topics">
                <h2>Serviços</h2>
                <span>Atendimentos online e presenciais</span>
                <br></br>
                <span>Crianças | Jovens | Adultos | Casais e Famílias</span>
            </div>
        </div>
    );
}

export default ServiceHomePage;